import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import SwitchTableAutomaticDebit from '../../components/SwitchTableAutomaticDebit';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { cga } from '../../helper/formatersMask';


function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}


function EnhancedTableHead(props) {
  const { order, orderBy } = props;
  // const createSortHandler = property => event => {
  //   onRequestSort(event, property);
  // };

  let headRows = []
  //1 - registerDebit | 2 - changeQuotas
  if(props.typeTable === 1){
    headRows = [
      { id: 'idItem', numeric: false, disablePadding: true, label: 'CÓDIGO' },
      { id: 'nInscricao', numeric: true, disablePadding: false, label: 'Nº DE INSCRIÇÃO' },
      { id: 'descricao', numeric: true, disablePadding: false, label: 'DESCRIÇÃO' },
      { id: 'opcaoPagamento', numeric: true, disablePadding: false, label: 'OPÇÃO DE PAGAMENTO' },
    ];
  } else if(props.typeTable === 2){
    headRows = [
      { id: 'idItem', numeric: false, disablePadding: true, label: 'CÓDIGO' },
      { id: 'nInscricao', numeric: true, disablePadding: false, label: 'Nº DE INSCRIÇÃO' },
      { id: 'descricao', numeric: true, disablePadding: false, label: 'DESCRIÇÃO' },
      { id: 'banco', numeric: true, disablePadding: false, label: 'BANCO' },
      { id: 'conta', numeric: true, disablePadding: false, label: 'CONTA' },
      { id: 'opcaoPagamento', numeric: true, disablePadding: false, label: 'OPÇÃO DE PAGAMENTO' },
    ];
  }

  return (
    <TableHead>
      <TableRow>
        {headRows.map(row => (
          <TableCell
            key={row.id}
            align={'left'}
            sortDirection={orderBy === row.id ? order : false}
            style={{'padding': '11px 40px 11px 16px', 'textAlign': 'left'}}
          >
            {row.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    position: 'relative',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  tableCell: {
    padding: '18px 40px 18px 16px',

    textAlign: 'left',
    color: '#636363',
  },
  highlight: {
    color:'#000',
    fontWeight: 500,
  }
}));

function EnhancedTable(props) {
  const classes = useStyles();
  const [order] = React.useState('asc');
  const [orderBy] = React.useState('name');
  const [selected] = React.useState([]);
  const [page] = React.useState(0);
  const [rowsPerPage] = React.useState(5);

  return (
    <div className={classes.root}>
      <Paper className={classes.paper} elevation={0}>
        <div className={classes.tableWrapper}>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size={'medium'}
          >
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              rowCount={props.rows.length}
              typeTable={props.typeTable}
            />
            <TableBody>
              {stableSort(props.rows, getSorting(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const labelId = `enhanced-table-checkbox-${index}`;

                  if(props.typeTable === 1){
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={row.IdItem}
                      >
                        <TableCell className={`${classes.tableCell} ${classes.highlight}`} component="th" id={labelId} scope="row">
                          {row.IdItem}
                        </TableCell>
                        <TableCell className={classes.tableCell} align="right">{cga(row.Contribuinte.NumInscricaoFormatado)}</TableCell>
                        <TableCell className={classes.tableCell} align="right">{row.Contribuinte.DescricaoDocumentoFiscal}</TableCell>
                        <TableCell className={classes.tableCell} align="right">
                        <SwitchTableAutomaticDebit idItem={row.IdItem} allowQuotas={row.Tributo.PermiteCotas}/>
                        </TableCell>
                      </TableRow>
                    );
                  } else if(props.typeTable === 2){
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={row.IdItem}
                      >
                        <TableCell className={`${classes.tableCell} ${classes.highlight}`} component="th" id={labelId} scope="row">
                          {row.IdItem}
                        </TableCell>
                        <TableCell className={classes.tableCell} align="right">{cga(row.Contribuinte.NumInscricaoFormatado)}</TableCell>
                        <TableCell className={classes.tableCell} align="right">{row.Contribuinte.DescricaoDocumentoFiscal}</TableCell>
                        <TableCell className={classes.tableCell} align="right">{row.Solicitacao.NomeBanco}</TableCell>
                        <TableCell className={classes.tableCell} align="right">{row.Solicitacao.NumeroConta}</TableCell>
                        <TableCell className={classes.tableCell} align="right">
                          <SwitchTableAutomaticDebit
                            idItem={row.IdItem}
                            opQuotas={row.Solicitacao.OpCotas}
                            allowQuotas={row.Tributo.PermiteCotas}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  }

                  return null;
                })}
            </TableBody>
          </Table>
        </div>
      </Paper>
    </div>
  );
}

export default EnhancedTable